module.exports = __webpack_public_path__ + "img/Feature.bcbc7e51.jpg";